// NPM Imports
import React, { Component, Fragment } from "react";
// import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import store from "../../../store";
import { FieldsSetting } from "../../../actions";
// Components Imports

const { setFlagForAgrgrid } = FieldsSetting;
class FieldDataDetails extends Component {
  state = {};

  togglePopUp = () => {
    const data = {
      showTableData: true,
      rowindex: this.props.node.rowIndex,
      colId: this.props.column.colId,
    };
    store.dispatch(setFlagForAgrgrid(data));
  };

  render() {
    return (
      <Fragment>
        <div
          data-test="table-text-ingrid"
          className="table-text-ingrid"
          onClick={() => this.togglePopUp("showTableData", true)}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          {this.props.value}
          <FontAwesomeIcon
            icon={["fas", "expand-alt"]}
            className="table-expand-button"
          />
        </div>
      </Fragment>
    );
  }
}

export default FieldDataDetails;
